var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtertech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 594,
    height: 681,
    viewBox: "0 0 594 681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-719 -396.954)",
    opacity: 0.104
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,0h0a0,0,0,0,1,0,0V195a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V105A105,105,0,0,1,105,0Z",
    transform: "translate(915 581.954)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,0h0a0,0,0,0,1,0,0V91A105,105,0,0,1,0,196H0a0,0,0,0,1,0,0V105A105,105,0,0,1,105,0Z",
    transform: "translate(915 881.954)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H196a0,0,0,0,1,0,0V105a0,0,0,0,1,0,0H105A105,105,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(719 776.954)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H0A105,105,0,0,1,105,105v87a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1208 584.954)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H188a0,0,0,0,1,0,0V0A105,105,0,0,1,83,105H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1020 776.954)",
    fill: "#00c68a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(1022 396.954)",
    fill: "#00c68a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtertech);
export default __webpack_public_path__ + "static/media/buttertech.4a74a3d4.svg";
export { ForwardRef as ReactComponent };